import axios from "axios";

export const scoreBaseURL =
	import.meta.env.VITE_SCORE_API_AC ?? import.meta.env.VITE_SCORE_API;

const scoreApiInstance = axios.create({
	baseURL: scoreBaseURL,
});

export const scoreApi = scoreApiInstance;
